module.exports = __webpack_public_path__ + "media/anruf_konrad_2.93616383.mp3";